import React from 'react';
import { Dialog, DialogContent, DialogClose } from '@/components/ui/dialog';
import Link from '@/components/atomic/Link';
import { AlertCircleIcon } from 'lucide-react';
import { isIOSNativeEnvironment } from '@/utils/nativeBridge';

const AppSupportEndingDialog = ({ setAppSupportEndingDialogSeen }) => {
  const isIos = isIOSNativeEnvironment();
  return (
    <Dialog
      defaultOpen
      onOpenChange={() =>
        setAppSupportEndingDialogSeen && setAppSupportEndingDialogSeen(true)
      }
    >
      <DialogContent className="flex max-w-[390px] justify-between p-6 w-full">
        <div className="flex flex-col justify-between items-center gap-4">
          <AlertCircleIcon stroke="#ef451f" />
          <p className="text-base leading-[21px] text-center max-w-[560px] font-normal tracking-normal">
            Vi satser for fult på nettleserversjonen. Der får du tilgang til
            alle nye funksjoner. Du finner den ved å besøke <b>boligmappa.no</b>{' '}
            i din nettleser.
          </p>
          {!isIos && (
            <DialogClose className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 px-4 py-2 bg-primary text-primary-foreground shadow hover:bg-primary">
              <Link
                className="!no-underline !text-white"
                to="https://www.boligmappa.no/"
                isExternal
                openInNewTab
              >
                Besøk Boligmappa på nettleser
              </Link>
            </DialogClose>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AppSupportEndingDialog;
